import { AI_VIDEO_CONTINUITY_FAQ } from '../aiVideoContinuityPage';
import { AGENCIES_FAQ } from '../forAgenciesPage';
import { ENTERPRISE_FAQ } from '../forEnterprisePage';
import { FILMMAKERS_FAQ } from '../forFilmmakersPage';
import { MODELS_FAQ } from '../productModelsPage';
import { SCRIPT_FAQ } from '../productScriptPage';
import { SHOT_CONTROL_FAQ } from '../productShotControlPage';
import { FAQS } from '../../data/faqs';

export type FaqItem = { readonly q: string; readonly a: string };

export type FaqSection = {
  readonly id: string;
  readonly title: string;
  readonly href?: string;
  readonly items: readonly FaqItem[];
};

export const FAQ_SECTIONS: readonly FaqSection[] = [
  { id: 'general', title: 'General', items: FAQS },
  { id: 'script-editor', title: 'Script to Video', href: '/product/script-editor', items: SCRIPT_FAQ },
  {
    id: 'ai-video-continuity',
    title: 'AI Video Continuity',
    href: '/product/ai-video-continuity',
    items: AI_VIDEO_CONTINUITY_FAQ,
  },
  { id: 'shot-control', title: 'Shot Control', href: '/product/shot-control', items: SHOT_CONTROL_FAQ },
  { id: 'models', title: 'AI Models', href: '/product/models', items: MODELS_FAQ },
  { id: 'filmmakers', title: 'For Filmmakers', href: '/for-filmmakers', items: FILMMAKERS_FAQ },
  { id: 'agencies', title: 'For Agencies', href: '/for-agencies', items: AGENCIES_FAQ },
  { id: 'enterprise', title: 'For Enterprise', href: '/for-enterprise', items: ENTERPRISE_FAQ },
];

export function getAllFaqItems(): FaqItem[] {
  return FAQ_SECTIONS.flatMap((section) => [...section.items]);
}
